import { render, staticRenderFns } from "./MessagePreview.vue?vue&type=template&id=da69c73e&"
import script from "./MessagePreview.vue?vue&type=script&lang=ts&"
export * from "./MessagePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports